export const PendingIcon = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* White circular background */}
      <circle cx="23" cy="23" r="23" fill="white" />

      <rect x="0.5" y="0.5" width="45" height="45" rx="22.5" stroke="#916CF1" />
      <path
        d="M19.7917 13.604H14.75V33.7707H19.7917V13.604Z"
        fill="white"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.8747 13.604H24.833V33.7707H29.8747V13.604Z"
        fill="white"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
